import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
var _process;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fg } from '@atlaskit/platform-feature-flags';
import { getConfig } from '../config';
import { VCObserverNOOP } from './no-op-vc-observer';
import { VCObserver } from './vc-observer';
import VCObserverNew from './vc-observer-new';
var VCObserverWrapper = /*#__PURE__*/function () {
  function VCObserverWrapper() {
    var _getConfig;
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, VCObserverWrapper);
    this.newVCObserver = null;
    var isNewVCObserverEnabled = fg('platform_ufo_vc_observer_new') || ((_getConfig = getConfig()) === null || _getConfig === void 0 || (_getConfig = _getConfig.vc) === null || _getConfig === void 0 ? void 0 : _getConfig.enableVCObserverNew);
    if (isNewVCObserverEnabled) {
      this.newVCObserver = new VCObserverNew({
        selectorConfig: opts.selectorConfig
      });
    }
    this.oldVCObserver = new VCObserver(opts);
  }
  return _createClass(VCObserverWrapper, [{
    key: "start",
    value: function start(startArg) {
      var _this$oldVCObserver, _this$newVCObserver;
      (_this$oldVCObserver = this.oldVCObserver) === null || _this$oldVCObserver === void 0 || _this$oldVCObserver.start(startArg);
      (_this$newVCObserver = this.newVCObserver) === null || _this$newVCObserver === void 0 || _this$newVCObserver.start({
        startTime: startArg.startTime
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this$oldVCObserver2, _this$newVCObserver2;
      (_this$oldVCObserver2 = this.oldVCObserver) === null || _this$oldVCObserver2 === void 0 || _this$oldVCObserver2.stop();
      (_this$newVCObserver2 = this.newVCObserver) === null || _this$newVCObserver2 === void 0 || _this$newVCObserver2.stop();
    }
  }, {
    key: "getVCRawData",
    value: function getVCRawData() {
      var _this$oldVCObserver$g, _this$oldVCObserver3;
      return (_this$oldVCObserver$g = (_this$oldVCObserver3 = this.oldVCObserver) === null || _this$oldVCObserver3 === void 0 ? void 0 : _this$oldVCObserver3.getVCRawData()) !== null && _this$oldVCObserver$g !== void 0 ? _this$oldVCObserver$g : null;
    }
  }, {
    key: "getVCResult",
    value: function () {
      var _getVCResult = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(param) {
        var _this$oldVCObserver4, _this$newVCObserver3, _ref;
        var oldResult, newResult;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (_this$oldVCObserver4 = this.oldVCObserver) === null || _this$oldVCObserver4 === void 0 ? void 0 : _this$oldVCObserver4.getVCResult(param);
            case 2:
              oldResult = _context.sent;
              _context.next = 5;
              return (_this$newVCObserver3 = this.newVCObserver) === null || _this$newVCObserver3 === void 0 ? void 0 : _this$newVCObserver3.getVCResult({
                start: param.start,
                stop: fg('platform_ufo_vc_ttai_on_paint') ? param.stop : performance.now()
              });
            case 5:
              newResult = _context.sent;
              if (!(oldResult && !newResult)) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return", oldResult);
            case 8:
              return _context.abrupt("return", _objectSpread(_objectSpread({}, oldResult !== null && oldResult !== void 0 ? oldResult : {}), {}, {
                'ufo:vc:rev': [].concat(_toConsumableArray((_ref = oldResult === null || oldResult === void 0 ? void 0 : oldResult['ufo:vc:rev']) !== null && _ref !== void 0 ? _ref : []), _toConsumableArray(newResult !== null && newResult !== void 0 ? newResult : []))
              }));
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getVCResult(_x) {
        return _getVCResult.apply(this, arguments);
      }
      return getVCResult;
    }()
  }, {
    key: "setSSRElement",
    value: function setSSRElement(element) {
      var _this$oldVCObserver5;
      (_this$oldVCObserver5 = this.oldVCObserver) === null || _this$oldVCObserver5 === void 0 || _this$oldVCObserver5.setSSRElement(element);
    }
  }, {
    key: "setReactRootRenderStart",
    value: function setReactRootRenderStart(startTime) {
      var _this$oldVCObserver6;
      (_this$oldVCObserver6 = this.oldVCObserver) === null || _this$oldVCObserver6 === void 0 || _this$oldVCObserver6.setReactRootRenderStart(startTime || performance.now());
    }
  }, {
    key: "setReactRootRenderStop",
    value: function setReactRootRenderStop(stopTime) {
      var _this$oldVCObserver7;
      (_this$oldVCObserver7 = this.oldVCObserver) === null || _this$oldVCObserver7 === void 0 || _this$oldVCObserver7.setReactRootRenderStop(stopTime || performance.now());
    }
  }]);
}(); // Some products set this variable to indicate it is running in SSR
var isServer = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
var isReactSSR = typeof process !== 'undefined' && Boolean(((_process = process) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.REACT_SSR) || false);
export function isEnvironmentSupported() {
  // SSR environment aren't supported
  if (isReactSSR || isServer) {
    return false;
  }

  // Legacy browsers that doesn't support WeakRef
  // aren't valid
  if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.WeakRef) !== 'function') {
    return false;
  }
  if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.MutationObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.IntersectionObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.PerformanceObserver) !== 'function') {
    return false;
  }
  return true;
}
export function getVCObserver() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!globalThis.__vcObserver) {
    var shouldMockVCObserver = !isEnvironmentSupported();
    globalThis.__vcObserver = shouldMockVCObserver ? new VCObserverNOOP() : new VCObserverWrapper(opts);
  }
  return globalThis.__vcObserver;
}